package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class SyndromeIndicationOverallPathogenesis(private val literal: String) : IEnumType {
	血虚("血虚"),
	津虚("津虚"),
	机能衰退("机能衰退"),
	机能亢进("机能亢进");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "syndrome_indication_overall_pathogenesis"}
	override fun getLiteral(): String {return literal}
}
